(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../util/convert', 'lodash/isArray', 'lodash/toArray'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../util/convert'), require('lodash/isArray'), require('lodash/toArray'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert, global.isArray, global.toArray);
    global.convertArrayMethod = mod.exports;
  }
})(this, function (exports, _convert, _isArray, _toArray) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.convertArrayMethod = undefined;

  var _isArray2 = _interopRequireDefault(_isArray);

  var _toArray2 = _interopRequireDefault(_toArray);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Converts an Array method.
   * @memberof array
   * @param {string} method Array method name.
   * @return {function} Returns the wrapped function.
   * @see {@link util.convert|convert} for more information.
   * @see {@link https://lodash.com/docs#isArray|lodash.isArray} for more information.
   * @see {@link https://lodash.com/docs#toArray|lodash.toArray} for more information.
   * @since 0.2.0
   * @private
   */
  var convertArrayMethod = function convertArrayMethod(method) {
    return (0, _convert.convert)(function (array) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newArray = (0, _isArray2.default)(array) ? array : (0, _toArray2.default)(array);
      newArray[method].apply(newArray, args);
      return newArray;
    });
  };

  exports.convertArrayMethod = convertArrayMethod;
  exports.default = convertArrayMethod;
});